import React, { PropsWithChildren } from 'react';

import './ghost-button.scss';

interface GhostButtonProps {
  isSelected?: boolean;
  isUnavailable?: boolean;
  onClick?: () => void;
}

function GhostButton(props: PropsWithChildren<GhostButtonProps>) {
  const { children, isSelected, isUnavailable, onClick } = props;
  let styleName = 'btn';

  if (isSelected) {
    styleName = 'btn-selected';
  } else if (isUnavailable) {
    styleName = 'btn-unavailable';
  }

  return (
    <button onClick={onClick} styleName={styleName} type="button">
      {children}
    </button>
  );
}

export default GhostButton;
